import React from "react";
import { Modal } from "react-bootstrap";
import { EMPTY_STRING } from "../../../constants";
import CustomSvg from "../custom-svg/CustomSvg";
import { CloseAdminModalIcon } from "../../../assets";

const BaseModal = React.memo((props) => {
  const {
    show,
    showClose = true,
    onClose,
    children,
    size,
    fullScreen = false,
    backDropClass = EMPTY_STRING,
    dialogClassName = EMPTY_STRING,
  } = props;
  return (
    <Modal
      size={size}
      centered
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={!!showClose}
      backdropClassName={`auth-modal-backdrop custom-modal-backdrop ${backDropClass}`}
      fullscreen={fullScreen}
      dialogClassName={`auth-modal ${dialogClassName} ${
        size === "xs" && !fullScreen ? "small-modal" : EMPTY_STRING
      }`}
      animation={false}
    >
      {showClose && (
        <CustomSvg
          src={CloseAdminModalIcon}
          className="base-modal-close"
          onClick={onClose}
        />
      )}
      <Modal.Body className="position-relative">{children}</Modal.Body>
    </Modal>
  );
});

export default BaseModal;
